var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<table class=\"backgrid table table-striped\">\n  <thead></thead>\n  <tbody></tbody>\n</table>\n<div class=\"paginator-container\"></div>";
},"useData":true});